<template>
  <footer class="sklib-footer">
    <p class="sklib-footer__copyright">
      <a href="https://beian.miit.gov.cn/" target="_blank">
        京ICP备05032912号-4
      </a>
      <a
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202010100"
        target="_blank"
        class="copyright__record"
      >
        <img src="https://www.sklib.cn/images/jgwab.png" />
        <span>京公网安备11010202010100号</span>
      </a>
    </p>
  </footer>
</template>

<script>
export default {
  name: "SklibFooter",
};
</script>

<style lang="scss" scoped>
.sklib-footer {
  padding: 8px 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #94a5bf;
  background-color: #303b4c;

  .sklib-footer__copyright {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    .copyright__record {
      margin-left: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>